import { deleteReq, post } from "../../service/api";

const UndoMerchantPermission = async (merchantId, permissionId) => {
  try {
    const response = await deleteReq(
      `/merchant/${merchantId}/permissions/${permissionId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error DeleteVatMerchant:", error);
    throw error;
  }
};

export default UndoMerchantPermission;
